import styled, { css, DefaultTheme } from 'styled-components';
import { BaseField as Field } from '@seller-hermes/features/ui/Field/field.styles';
import { StyledNiceInputPassword as PasswordInput } from '@seller-hermes/features/ui/PasswordInput/password-input.styles';
import { Link as BaseLink } from 'react-router-dom';

const mapColors = ({ theme }: { theme: DefaultTheme }) =>
  theme.type === 'light'
    ? {
        $bg: theme.colors.white[1000],
        $header: theme.colors.black[900],
        $subheader: theme.colors.black[800],
      }
    : {
        $bg: theme.colors.black[800],
        $header: theme.colors.white[1000],
        $subheader: theme.colors.white[900],
      };

export const Container = styled.div.attrs(mapColors)`
  border-radius: ${(p) => p.theme.borderRadius};
  background-color: ${(p) => p.$bg};
  box-shadow: ${(p) => p.theme.type === 'light' && p.theme.defaultShadow};
  width: 100%;
  max-width: 500px;
  padding: 1rem 0;
  max-width: 800px;
  min-width: unset;
  border-radius: 20px;
  padding: 20px 20px;
  margin: 20px 0;

  @media (max-width: 800px) {
    max-width: 720px;
    margin: 0 auto;
  }

  & .MuiButton-containedPrimary {
    height: 58px;
    padding: 0 40px;
    font-weight: bold;
  }
`;

export const Header = styled.h1.attrs(mapColors)`
  text-align: center;
  font-size: 4rem;
  color: ${(p) => p.$header};
  margin: 10px 0;
`;

export const SubHeader = styled.h4.attrs(mapColors)`
  text-align: center;
  font-size: 2rem;
  color: ${(p) => p.$subheader};
  margin: 10px 0;
`;

export const FieldsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 5px 20px;

  ${Field}, ${PasswordInput} {
    margin-right: 10px;
  }
  ${Field}:last-of-type, ${PasswordInput}:last-of-type {
    margin-right: 0;
  }
  & .MuiButton-containedPrimary {
    margin-left: 10px;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
    ${Field} {
      margin-bottom: 10px;
    }
    ${Field}:last-of-type {
      margin-bottom: 0;
    }
    & .MuiButton-containedPrimary {
      width: 100%;
      margin-left: unset;
      margin-top: 10px;
      padding: 10px 20px;
      font-size: 2rem;
    }
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px 20px;
`;

export const Highlight = styled.span`
  color: ${(p) => p.theme.sellerTheme.primary.value};
  ${(p) =>
    p.onClick &&
    css`
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    `}
`;

export const Link = styled(BaseLink)`
  font-size: 1.8rem;
  color: ${(p) => p.theme.sellerTheme.primary.safeColorAgainstBg};
  margin: 0.8rem 0.5rem;
  &:hover {
    text-decoration: underline;
  }
`;
